import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import MainLayout from "../../layout/MainLayout";

const SewaClientEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Fetch client data
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const res = await axios.get(`https://bpohasil.ngrok.app/api/client/${id}`);
        setClient(res.data.client);
      } catch (err) {
        setError("Failed to fetch Sewa Client data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchClient();
  }, [id]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setClient((prev) => ({ ...prev, [name]: value }));
  };

  // Handle update
  const handleUpdate = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      await axios.put(`https://bpohasil.ngrok.app/api/client/${id}`, client);
      alert("Sewa client updated successfully!");
      navigate("/scanner");
    } catch (err) {
      console.error(err);
      setError("Failed to update Sewa Client data.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-gray-600">Loading Sewa Client data...</p>;
  if (error) return <p className="text-red-600">{error}</p>;
  if (!client) return <p>No client found.</p>;

  return (
  <MainLayout>
    <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg p-6 mt-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-700">Edit Sewa Client</h2>

      <form onSubmit={handleUpdate} className="grid grid-cols-2 gap-4 text-sm">
        {/* ID (readonly) */}
        <div className="col-span-2">
          <label className="block text-gray-600">ID</label>
          <input
            type="text"
            name="id"
            value={client.id || ""}
            readOnly
            className="border rounded-md w-full p-2 bg-gray-100"
          />
        </div>

        <div>
          <label className="block text-gray-600">KPI Type</label>
          <input
            type="text"
            name="kpiType"
            value={client.kpiType || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">KPI</label>
          <input
            type="text"
            name="kpi"
            value={client.kpi || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Zone ID</label>
          <input
            type="text"
            name="zoneId"
            value={client.zoneId || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Area ID</label>
          <input
            type="text"
            name="areaId"
            value={client.areaId || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Kawasan Sewa</label>
          <input
            type="text"
            name="rentalArea"
            value={client.rentalArea || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Kategori Sewa</label>
          <input
            type="text"
            name="rentalCategory"
            value={client.rentalCategory || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Nama</label>
          <input
            type="text"
            name="name"
            value={client.name || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Kad Pengenalan</label>
          <input
            type="text"
            name="identificationNumber"
            value={client.identificationNumber || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Unit</label>
          <input
            type="text"
            name="unitNumber"
            value={client.unitNumber || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Harta</label>
          <input
            type="text"
            name="propertyNumber"
            value={client.propertyNumber || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Akaun</label>
          <input
            type="text"
            name="accountNumber"
            value={client.accountNumber || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Status</label>
          <select
            name="status"
            value={client.status || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          >
            <option value="AKTIF">AKTIF</option>
            <option value="TIDAK AKTIF">TIDAK AKTIF</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-600">Penerima Bantuan</label>
          <select
            name="aidRecipient"
            value={client.aidRecipient || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          >
            <option value="YA">YA</option>
            <option value="TIDAK">TIDAK</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-600">Potongan Gaji</label>
          <select
            name="salaryDeduction"
            value={client.salaryDeduction || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          >
            <option value="YA">YA</option>
            <option value="TIDAK">TIDAK</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-600">Kadar Sewa</label>
          <input
            type="number"
            step="0.01"
            name="rentalRate"
            value={client.rentalRate || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Diskaun</label>
          <input
            type="number"
            step="0.01"
            name="discount"
            value={client.discount || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Caj Sewa</label>
          <input
            type="number"
            step="0.01"
            name="rentalCharge"
            value={client.rentalCharge || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Tunggakan</label>
          <input
            type="number"
            step="0.01"
            name="arrears"
            value={client.arrears || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Bayaran</label>
          <input
            type="number"
            step="0.01"
            name="payment"
            value={client.payment || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        {/* Submit */}
        <div className="col-span-2 flex justify-end mt-4">
          <button
            type="submit"
            disabled={saving}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            {saving ? "Saving..." : "Update"}
          </button>
        </div>
      </form>
    </div>
    </MainLayout>
  );
};

export default SewaClientEdit;
